import apiClient from '@/services/axios'

export async function get( venueDetailsId) {

  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/events/by-venue/' + venueDetailsId);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get events')
}
